import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { removeNotificationMessages } from "../../../redux/features/appStateSlice";

interface IAlertProps {
  children: React.ReactElement;
}

export default function AlertMessage({ children }: IAlertProps) {
  const message = useAppSelector(
    (state) => state.appState.notificationMessages
  );
  const displayedMessages = useRef<any[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    message.forEach((e: any) => {
      if (!displayedMessages.current.some((g: any) => g.id === e.id)) {
        enqueueSnackbar(e.message, {
          key: e.id,
          variant: e.code,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
          onClose: (e: any, r: any, k: any) => {
            displayedMessages.current = displayedMessages.current.filter(d => d.id !== k);
            dispatch(removeNotificationMessages(k));
        },
        });
        displayedMessages.current.push(e);
      }
    });
  }, [message]);

  return (
    <Box>
      {message.length > 0 && <SnackbarProvider />}
      {children}
    </Box>
  );
}
